var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99,
    height: 43,
    viewBox: "0 0 99 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161254",
    "data-name": "Rectangle 161254",
    width: 44.677,
    height: 14.429
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161405",
    "data-name": "Rectangle 161405",
    width: 99,
    height: 43,
    rx: 5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174182",
    "data-name": "Group 174182",
    transform: "translate(26.55 14.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173799",
    "data-name": "Group 173799",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38068",
    "data-name": "Path 38068",
    d: "M16.963.255,11.114,14.211H7.3L4.42,3.073a1.529,1.529,0,0,0-.858-1.226A15.115,15.115,0,0,0,0,.661L.086.255H6.228A1.682,1.682,0,0,1,7.893,1.678l1.52,8.075L13.17.255h3.793Zm14.952,9.4c.015-3.683-5.093-3.886-5.058-5.532.011-.5.488-1.033,1.531-1.169a6.811,6.811,0,0,1,3.559.625L32.582.619A9.7,9.7,0,0,0,29.205,0c-3.568,0-6.08,1.9-6.1,4.613-.023,2.009,1.792,3.13,3.16,3.8,1.407.684,1.879,1.123,1.874,1.734-.01.936-1.122,1.349-2.162,1.366a7.562,7.562,0,0,1-3.707-.881l-.654,3.057a10.947,10.947,0,0,0,4.015.742c3.793,0,6.274-1.873,6.285-4.775m9.423,4.556h3.339L41.763.255H38.681a1.643,1.643,0,0,0-1.536,1.024L31.727,14.211h3.791l.753-2.084H40.9ZM37.31,9.266l1.9-5.24L40.3,9.266ZM22.121.255,19.136,14.211h-3.61L18.513.255Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e33957182a6da3304beb55483c15aa8b.svg";
export { ForwardRef as ReactComponent };